import React from 'react';

import { ThreeColorGraph } from '~/components/lawns/digital-soil-test/common/generic-graphs';
import Tooltip from '~/components/tooltip/tooltip';

import styles from '~/components/lawns/digital-soil-test/digital-soil-test.module.scss';

const CationExchangeGraph = ({ cationExchange }) => (
  <div className={styles.graphContainer}>
    <h4 className={styles.graphTitle}>
      cation exchange{' '}
      <Tooltip content="The soil’s ability to retain water and nutrients. Lower CEC means the soil is less able to hold nutrients and vice versa. Nutrient applications can be adjusted to fit your soil’s CEC." />{' '}
    </h4>
    <ThreeColorGraph value={cationExchange} />
  </div>
);

export default CationExchangeGraph;
